export default __webpack_public_path__ + "static/media/cover.ca670118.jpg";